const SET_SMALL_SCREEN = 'SET_DISPLAY_WIDTH';
const SET_LIST_RELATION = 'SET_LIST_RELATION';
const SET_VISITOR_ID = 'SET_VISITOR_ID';

const setSmallScreen = (payload) => ({
  type: SET_SMALL_SCREEN,
  payload,
})

const setListRelation = (payload) => ({
  type: SET_LIST_RELATION,
  payload, 
});

const setVisitorId = (visitorId) => ({
  type: SET_VISITOR_ID,
  payload: visitorId,
});

export {
  SET_SMALL_SCREEN,
  setSmallScreen,
  SET_LIST_RELATION,
  setListRelation,
  SET_VISITOR_ID,
  setVisitorId,
}
